import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AccessRequestMode,
  IAccessRequest,
  IAccessRequestlFieldUpdate,
  IAccessRequestState
} from 'src/types/AccesRequest';

const initialState: IAccessRequestState = {
  accessRequest: {},
  open: false,
  mode: AccessRequestMode.None
};

export const accessRequest = createSlice({
  name: 'accessRequest',
  initialState,
  reducers: {
    clearAccessRequest: state => {
      state.accessRequest = {};
    },
    clearAccessRequestState: state => {
      state.accessRequest = {};
      state.open = false;
      state.mode = AccessRequestMode.None;
    },
    setAccessRequest: (state, action: PayloadAction<Partial<IAccessRequest>>) => {
      state.accessRequest = action.payload;
    },
    openAccessRequest: state => {
      state.open = true;
    },
    closeAccessRequest: state => {
      state.open = false;
      state.accessRequest = {};
    },
    setAccessRequestField: (state, action: PayloadAction<IAccessRequestlFieldUpdate>) => {
      state.accessRequest[action.payload.key] = action.payload.value;
    }
  }
});

export const {
  clearAccessRequest,
  clearAccessRequestState,
  setAccessRequestField,
  openAccessRequest,
  closeAccessRequest
} = accessRequest.actions;
